module.exports = __webpack_public_path__ + "static/media/Loading999.1f050407.gif";